import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'

// 일반 요청 타임아웃
const DEFAULT_TIMEOUT_MS = 30000
// 배치 서버를 동기로 호출해 오래 걸리는 요청용 타임아웃
// (API 의 배치 read timeout 300초 + 여유). 요청별로 개별 지정한다.
export const LONG_RUNNING_TIMEOUT_MS = 310000

const axiosClient = axios.create({
  baseURL: '/api',
  timeout: DEFAULT_TIMEOUT_MS,
  headers: { 'Content-Type': 'application/json' },
})

// 요청 인터셉터: JWT 토큰 자동 첨부
axiosClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// 응답 인터셉터: 401 → 로그인 페이지 이동 (이미 로그인 페이지인 경우 제외)
axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default axiosClient
